import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ICustomer } from 'src/app/domain/customer/ICustomer';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from './crud-config';
import { CustomerToUpdatePlansService } from './crud-service';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { CustomerToUpdatePlansReasonDialog } from './customer-to-update-plans-reason-dialog/customer-to-update-plans-reason-dialog.component';

@Component({
  selector: 'app-customer-to-update-plans',
  templateUrl: './customer-to-update-plans.component.html',
  styleUrls: ['./customer-to-update-plans.component.sass'],
})
export class CustomerToUpdatePlansComponent
  extends AbstractCrudIndex<ICustomer>
  implements OnInit, ITableResponsive
{
  override configColumns = TABLE_CONFIG_COLUMNS;

  constructor(
    public override dialog: MatDialog,
    public override service: CustomerToUpdatePlansService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.title = service.pluralTitle.toUpperCase();
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngOnInit(): void {
    this.loadList();
  }

  applyConfirm() {
    let selecteds = this?.selection?.source?._selected || [];
    if (selecteds?.length === 0) {
      this.toastService.showWarn('Selecione ao menos um item');
      return;
    }

    let ids = selecteds.map((s: any) => s.id);
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerToUpdatePlansReasonDialog,
      data: { title: 'Motivo da alteração' },
      callBack: (data: any) => {
        if (data?.result) {
          this.apply(ids, data.updateReason); // Aplica os dados (envia para o backend)
        }
      },
    });
  }

  apply(ids: any, reason: string) {
    this.service.apply({ ids, reason }).subscribe(
      (res) => {
        this.toastService.showSuccess('Operação realizada com sucesso');
        this.loadList();
      },
      (err) => {
        this.toastService.showError(err);
      }
    );
  }

  cancel() {
    this.dialog.closeAll();
  }
}
